<template>
    <div class="consumers">
        <div class="title">
            <router-link :to="{ name: 'ConsumersCreate' }" v-if="role == 'admin'">
                <IconComponent class="icon" icon="add" />
            </router-link>
        </div>
        <TableComponent :columns="filterColumns" :elements="consumers"
            :destination="(consumer) => ({ name: 'ConsumersInfo', params: { id: consumer.id } })" />
    </div>
</template>

<script>
import IconComponent from '@/components/Icons.vue'
import TableComponent from "@/components/Table.vue"
export default {
    name: 'ConsumersList',
    components: {
        IconComponent,
        TableComponent,
    },
    props: {},
    data() {
        return {
            columns: [
                { logo: 'logoUrl', type: 'image', attribute: 'logo' },
                { text: this.$t('name'), attribute: 'name' },
                // { text: this.$t('project', 0), attribute: 'projects' },
                // { text: this.$t('file', 0), attribute: 'files' },
                { text: this.$t('registered'), attribute: 'registered' },
                { icon: 'trash', method: this.delete, role: 'admin' }
            ],
        };
    },
    methods: {
        delete(consumer) {
            if (this.role == 'admin') {
                this.$store.dispatch('consumers/delete', consumer.id)
            }
        },
    },
    computed: {
        consumers() {
            const consumers = this.$store.state.consumers.all
            return consumers.sort((a, b) => {
                if (a.name == null || b.name == null) return
                return a.name.localeCompare(b.name)
            })
        },

        role() {
            return this.$store.state.users.role;
        },

        filterColumns() {
            return this.columns.filter((column) => !column.role || column.role == this.role)
        },
    },
    mounted() {
        this.$store.dispatch('consumers/getAll');
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.consumers {

    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .icon {
            width: 20px;
            height: 20px;
            fill: var(--text-color);
        }
    }
}

::v-deep(.logoUrl img) {
    width: 40px;
    height: auto;
    max-height: 40px;
    object-fit: contain;
}
</style>
